import { useEffect, useRef, useState } from "react";
import Reach from "../components/reach"
import Testimonial from "../components/testimonial"
import "./about.css"
import { motion, useTransform, useScroll } from "motion/react"
import PopForm from "../components/popForm";

export default function About(){
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);
    
    const {scrollY} = useScroll()
    const rotate = useTransform(
      scrollY,
      [0, 300],
      [0, 310],
      { clamp: false }
    )

    const scrollRefAbout = useRef(null)

    const [pop, setPop] = useState(sessionStorage.getItem('pop'))
    const closePop = ()=>{
      sessionStorage.setItem('pop', true);
      setPop(true)
    }
    return(
        <>
        <div className="wrapper">
            <section className="container homeLanding aboutLanding">
                <header>
                    <h1>Pledged Gold are saved</h1>
                </header>
                <figure className="aboutLandingJewell">
                    <img src="../images/aboutLanding.png" alt="jewell"/>
                </figure>
                <figure className="landingDecor">
                    <motion.img 
                    style={{
                        rotate
                    }}
                    src="../images/flower_1.svg" alt="decor"/>
                </figure>
            </section>
            <section ref={scrollRefAbout} className="container homeAbout aboutContant">
                <figure className="flower2">
                    <img src="../images/flower_2.png" alt="flower"/>
                </figure>
                <motion.main
                    initial={{ opacity: 0, translateY:100, }}
                    whileInView={{ opacity: 1,translateY:0  }}
                    viewport={{ root: scrollRefAbout, once:true }}
                    transition={{duration:.5, delay:0.25}}
                >
                    <article>
                        <h2 style={{marginBottom:"3rem"}}>About Aurum</h2>
                        <p>The Aurum Gold Company was established in the year 2024. Aurum Gold is an ISO 9001:2015 certified company. We buy all types of gold coins, jewelry, and biscuits and lend money to release pledged gold from financial institutes/pawns and brokers/NBFCs. We offer instant spot cash for gold and silver. Selling gold at Aurum Gold Company is fast, simple, and easy.<br/><br/>

                            Gold may be a popular item throughout India. The online gold rate is determined by global trends. Gold prices are volatile and are affected by a variety of factors, including the strength of the US dollar and seasonal demand within the country. Gold investment portfolios are profitable due to their steadiness. Indians think that investing in gold will provide them with future advantages in the form of profits. Individuals place their trust in gold as a vital investment in their wealth.<br/><br/>

                            There are several jewelry stores where you may get real gold goods for investment or personal use. However, before making the purchase, it is recommended that you conduct some online research to determine the value of gold. The gold rate fluctuates throughout the day; therefore, you’d want to view it on a certain day as well. Below we update the exact online gold price.</p>
                    </article>            
                </motion.main>
                <figure className="aboutDecor_1">
                    <motion.img
                     style={{
                        rotate
                        }}
                     src="../images/shape_1.png" alt="shape"/>
                </figure>
            </section>
            <Testimonial/>
            <Reach/>
        </div>
        {pop?null:<PopForm close={closePop}/>}
        </>
    )
}